import React from 'react';
import { Button } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { PATH } from 'constants/path';
import { IDLE_COPY } from '../copy';
import s from '../s.module.less';

type Props = {
    persona: 'managed' | 'manual';
    hasUpcomingBooking: boolean;
    onCheck: () => void;
};

// manual 的按钮下方两行：价格提示 + Enroll 链接。idle 与「先选一张保险」卡共用，两处说法不能漂
export const ManualIdleFoot: React.FC = () => {
    const navigate = useNavigate();
    return (
        <>
            <div className={s.idleHint}>{IDLE_COPY.manualHint}</div>
            {/* 未注册者落到 Insurance billing 的 pitch 页——那是目的地不是兜底（PRD §8 转化指标） */}
            <a
                className={s.enrollLink}
                href={`${PATH.DASHBOARD}/${PATH.INSURANCE_BILLING}`}
                onClick={(e) => {
                    e.preventDefault();
                    navigate(`${PATH.DASHBOARD}/${PATH.INSURANCE_BILLING}`);
                }}
            >
                {IDLE_COPY.enrollLink}
            </a>
        </>
    );
};

// 从未查过时的三种 idle 态：
// managed + 有 booking → 只读说明（首检自动跑，没有 CTA）
// managed + 无 booking → 免费 Check 按钮
// manual → Check CTA + 价格提示 + Enroll 链接（eligibility 流里唯一带 program offer 的位置）
const IdleCard: React.FC<Props> = ({ persona, hasUpcomingBooking, onCheck }) => {
    if (persona === 'managed' && hasUpcomingBooking) {
        return <div className={s.idleHint}>{IDLE_COPY.managedWithBooking}</div>;
    }
    if (persona === 'managed') {
        return (
            <div className={s.idleWrap}>
                <div className={s.idleHint}>{IDLE_COPY.managedNoBooking}</div>
                <Button type="primary" icon={<SearchOutlined />} onClick={onCheck}>
                    {IDLE_COPY.checkCta}
                </Button>
            </div>
        );
    }
    return (
        <div className={s.idleWrap}>
            <Button type="primary" icon={<SearchOutlined />} onClick={onCheck}>
                {IDLE_COPY.checkCta}
            </Button>
            <ManualIdleFoot />
        </div>
    );
};

export default IdleCard;
